import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ApiResourceLocation,
  Dictionary,
  ResponseResult,
} from '@softline/core';
import { SOFTLINE_API_GARAGE_ITEM_SCAN } from '../garage.api';

export interface ScannedProduct {
  id: number;
  number?: string;
  name?: string;
  matchcode?: string;
  supplierItemNumber?: string;
}

/** Raw item shape returned by the scan endpoint (German field names). */
interface ScannedArtikel {
  id: number;
  nummer?: string;
  artbez1?: string;
  artbez2?: string;
  ean?: string;
}

@Injectable()
export class ItemScanRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  async resolve(labelType: string, data: string): Promise<ScannedProduct | null> {
    const response = await this.#dataAccess.get<
      ResponseResult<{ artikel: ScannedArtikel | null }>
    >(this.createLocation(SOFTLINE_API_GARAGE_ITEM_SCAN, { labelType, data }));
    const artikel = response?.result?.artikel;
    if (!artikel) return null;
    // Map the raw German fields onto the ScannedProduct shape the form expects.
    return {
      id: artikel.id,
      number: artikel.nummer,
      name: artikel.artbez1,
      matchcode: artikel.artbez1,
    };
  }
}
